import { c as _c } from "react/compiler-runtime";
import { getOrgReviewAgentsOptions, getOrgReviewAgentsReviewsOptions } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import { useQuery } from '@tanstack/react-query';
import useSession from '@/hooks/use-session';
const useAssignedReviews = () => {
  const $ = _c(12);
  const session = useSession();
  const userId = session.data.user?.id;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgReviewAgentsOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: reviewAgents
  } = useQuery(t0);
  let t1;
  if ($[1] !== reviewAgents || $[2] !== userId) {
    t1 = reviewAgents?.some(agent => agent.tenantUserId === userId) ?? false;
    $[1] = reviewAgents;
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isReviewAgent = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getOrgReviewAgentsReviewsOptions();
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isReviewAgent) {
    t3 = {
      ...t2,
      enabled: isReviewAgent
    };
    $[5] = isReviewAgent;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  const {
    error
  } = query;
  let t4;
  if ($[7] !== error) {
    t4 = error ? getErrorMessage(error) : undefined;
    $[7] = error;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const errorMessage = t4;
  let t5;
  if ($[9] !== errorMessage || $[10] !== query) {
    t5 = {
      ...query,
      errorMessage
    };
    $[9] = errorMessage;
    $[10] = query;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default useAssignedReviews;